module.exports = __webpack_public_path__ + "img/RequestSuccess_Area-light.9285499b.svg";